import {
  breakpoints,
  customScrollMinimal,
  DropdownMenu,
  typographyV2,
} from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const attachmentDropdownStyles = css`
  padding: 8px 12px;
  max-height: 250px;
  overflow-y: auto;
  ${customScrollMinimal};

  @media ${breakpoints['max-sm']} {
    width: 250px;
    min-width: 250px;
  }
`;

export const BaseStyledDropdownMenu = styled(DropdownMenu)`
  ${attachmentDropdownStyles}
`;

export const BaseInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const BasePillLabel = styled.span`
  ${typographyV2.bodySm};
`;
